/* eslint-disable prettier/prettier */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable import/order */
import { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Span } from 'libs/common-components/src';
import dayjs from 'dayjs';
import { IOrganizationTypeData } from '@bvi/api-interfaces/response/manage-base-data';
import { OrganizationTypeActionMenu } from '@bvi/admin-panel/feature/organization-types/ui/organization-type-action-menu';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/manage-base-row/styles';

interface IOrganizationTypeTableRowProperties {
  organizationType: IOrganizationTypeData;
}

export const OrganizationTypeTableRow: FC<IOrganizationTypeTableRowProperties> = ({
  organizationType,
  ...properties
}) => {
  const dateFormatted = dayjs(organizationType.createdAt).format('MM/DD/YYYY');

  return (
    <TableRow {...properties}>
      <TableCell>
        <Span sx={styles.tooltipContent}>{organizationType.id}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{organizationType.name}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{dateFormatted}</Span>
      </TableCell>
      <TableCell>
        <OrganizationTypeActionMenu
          id={organizationType.id}
          detail={organizationType}
        />
      </TableCell>
    </TableRow>
  );
};

